import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@material-ui/core";
import React from "react";

// No onClose on purpose: the answer is mandatory (further scans are blocked while a
// question is pending), so backdrop click / Esc must not silently act as "No".
export const ConfirmYesNoDialog = ({ titleKey, messageKey, translate, onConfirm, onReject, children }) => (
	<Dialog open disableBackdropClick disableEscapeKeyDown maxWidth="sm" fullWidth>
		<DialogTitle>{translate(titleKey)}</DialogTitle>
		<DialogContent>
			<Box mb={1}>{children}</Box>
			<Typography>{translate(messageKey)}</Typography>
		</DialogContent>
		<DialogActions>
			<Button onClick={onReject} color="secondary">
				{translate("osfc.buttons.no")}
			</Button>
			<Button onClick={onConfirm} color="primary" variant="contained">
				{translate("osfc.buttons.yes")}
			</Button>
		</DialogActions>
	</Dialog>
);
